import Component from '../core/Component'

export default class ItemsCorrection extends Component {

    constructor(element) {
        super(element);
        let delay = 0;
        let speed = 1000;

        if (this.element.dataset.delay) {
            delay = parseInt(this.element.dataset.delay)
        }

        if (this.element.dataset.speed) {
            speed = parseInt(this.element.dataset.speed)
        }

        const itemsCorrection = document.querySelector(".itemsCorrection");
        let itemsCorrectionTimer = [],
            itemsCorrectionObserver = new MutationObserver(observerCallback),
            itemsCorrectionItems = document.querySelectorAll(".itemsCorrection-item");

        itemsCorrectionObserver.observe(itemsCorrection, {
            attributes: true,
            attributeFilter: ["class"]
        });

        function observerCallback() {
            itemsCorrection.classList.contains('seen') ? itemsCorrectionAnimation(true) : itemsCorrectionAnimation(false);
        }

        function itemsCorrectionAnimation(playState) {
            if (playState == true) {
                setTimeout(function () {
                    for (let i = 0; i < itemsCorrectionItems.length; i++) {
                        itemsCorrectionTimer.push(setTimeout(function () {
                            itemsCorrectionItems[i].classList.add("correction");
                        }, i * speed));
                    }
                }, delay);
            }
            if (playState == false) {
                itemsCorrectionTimer.forEach(function (timer) {
                    clearTimeout(timer);
                });
                for (let i = 0; i < itemsCorrectionItems.length; i++) {
                    itemsCorrectionItems[i].classList.remove("correction");
                }
            }
        }
    }
    prepare() {}
}
